export const routes = {
    login: "/login",
    registerOrLogin: "/register-or-login",
    register: "/register",
    registerStepTwo: "/register/step-two",
    registerStepThree: "/register/step-three",
    registerStepFour: "/register/step-four",
    registerUpgrade: "/register/upgrade",
    registerFreeTrial: "/register/free-trial",
    upgrade: "/upgrade",
    forgotPassword: "/forgot-password",
    resetPassword: "/reset-password",
    match: "/match",
    createMatch: "/create-match",
    addResult: "/add-result",
    addMultipleMatches: "/add-multiple-matches",
    addResultDetail: "/formDetail",
    mockWatchMessaging: "/mock-watch",
    teamPacks: "/manage/teamPacks",
    developerTools: "/developer-tools",
    pouchDebug: "/pouch-debug",
    pouchDebugMatch: "/pouch-debug-match",
    garminDebugger: "/garmin-debugger",
    moreProfile: "/more/profile",
    moreNotifications: "/more/notifications",
    moreSubscriptions: "/more/subscriptions",
    subscriptionCancel: "/subscriptions/cancel",
    moreSettings: "/more/settings",
    moreWatchDebug: "/more/watch-debug",
    startWatchPhone: "/more/start-watch-phone",
    moreSupport: "/more/support",
    timerOptions: "/settings/timer-options",
    moreSupportContact: "/support/contact",
    moreIntegrations: "/more/integrations",
    moreSettingsMisconductCodes: "/settings/misconduct-codes",
    moreSettingsEditCustomMisconductCodes: "/misconduct-codes/edit-custom",
    moreSettingsTemplates: "/settings/templates",
    moreSettingsTemplatesTemplate: "/templates/template",
    addEditTeamSheet: "/add-edit-teamsheet",
    requestTeamSheet: "/request-teamsheet",
    resultsAddEvent: "/results/event",
    activityGraphComparison: "/activity-graph-comparison",
    moreSettingsManageWatches: "/settings/manage-watches",
    moreSettingsManageWatchesPair: "/settings/watches/pair",
    moreSettingsSyncCalendar: "/settings/calendar-sync",
    moreSettingsPushConsent: "/settings/push-consent",
    tab: "/tab",
    tabFixtures: "/tab/fixtures",
    tabResults: "/tab/results",
    tabTrends: "/tab/trends",
    tabMore: "/tab/more",
    tabMoreIAP: "/tab/more/iap",
    onboardingGettingStarted: "/onboarding/getting-started",
    onboardingFoundWatch: "/onboarding/found-watch",
    onboardingNoWatchFound: "/onboarding/no-watch-found",
    onboardingPairWatch: "/onboarding/pair-watch",
    onboardingSelectGarmin: "/onboarding/select-garmin-watch",
    onBoardingShareLocationData: "/onboarding/share-location-data",
    onBoardingShareHealthData: "/onboarding/share-health-data",
    permissionsLocationData: "/permissions/location-data",
    permissionsHealthData: "/permissions/health-data",
    onBoardingTimerSettings: "/onboarding/timer-settings",
    onBoardingTimerSettingsStepTwo: "/onboarding/timer-settings-step-two",
    onBoardingSetupComplete: "/onboarding/setup-complete",
    resultsFilters: "/results/filters",
    fixturesFilter: "/fixtures/filters",
    trendsFilter: "/trends/filters",
    review: "/review",
    migrateSystemB: "/migrate-system-b",
    referFriend: "/refer-friend",
    addKnvbMatch: "/add-knvb-match",
    fitnessDataStatus: "/fitness-data-status",
    editMatchDetails: "/edit-match-details",
    // Venue leaderboards (SCORZA-739). Two entry shapes: `/venue/:venueId` for a deep link, and
    // `/venue?lat=&lon=&venueName=` from a match summary, which only knows where it was played.
    venue: "/venue",
};

export const sentryDsn =
    "https://b61979c5c9435e1f34c0dc10b9893c66@o946727.ingest.us.sentry.io/4509638131843072";

/**
 * The deploy target this bundle was built for, as named in `.env-cmdrc`:
 * "production" | "staging" | "testing" | "local" | "workspace" |
 * "ci-pipeline-tests" | "tim" | "anup".
 *
 * Prefer this over NODE_ENV. react-scripts hardcodes NODE_ENV to "production"
 * for *any* `build` and "development" for *any* `start`, so NODE_ENV tells you
 * how the bundle was compiled, never which backend it points at — a staging
 * build and a production build are both NODE_ENV=production.
 *
 * "unknown" means the build skipped env-cmd (e.g. a bare `npm run build`).
 */
export function scorzaEnv(): string {
    return process.env.REACT_APP_SCORZA_ENV || "unknown";
}

/**
 * Deploy targets whose builds report to Sentry. Add "testing" here if QA
 * builds should report too — they currently don't.
 */
const SENTRY_REPORTING_ENVS = ["production", "staging"];

/**
 * Whether error reporting should be sent to Sentry.
 *
 * Two gates, because NODE_ENV and the deploy target answer different questions:
 *  - NODE_ENV !== "production" means a dev server (`react-scripts start`).
 *    Those never report, whichever env file they were started with. This is
 *    what silences local dev and the Playwright/CI server on :4173, which
 *    together were ~62% of all ingested events.
 *  - Of the remaining built bundles, only real deploy targets report. This
 *    keeps `build-local` / `build-testing` / `build-tim` / `build-anup`
 *    (personal + QA device builds pointing at non-prod backends) out.
 *
 * Set REACT_APP_SENTRY_ENABLED to "true"/"false" to override either gate.
 */
export function sentryEnabled(): boolean {
    const override = process.env.REACT_APP_SENTRY_ENABLED;
    if (override !== undefined && override !== "") {
        return override === "true";
    }
    if (process.env.NODE_ENV !== "production") {
        return false;
    }
    const enabled = SENTRY_REPORTING_ENVS.includes(scorzaEnv());
    if (!enabled && scorzaEnv() === "unknown") {
        // Loud, because silently losing production reporting is expensive.
        console.warn(
            "Sentry disabled: REACT_APP_SCORZA_ENV is unset. Build via " +
                "env-cmd (e.g. `npm run build-production`), not a bare `build`."
        );
    }
    return enabled;
}
